import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "We take Carpe Diem too seriously",
  "description": "",
  "published": "2012-01-02T00:00:00.000Z",
  "redirect_from": ["/blog/we-take-carpe-diem-too-seriously/swizec/3304"],
  "categories": "Carpe Diem, Daytum, Holidays, New Year, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I received the best gift ever - a day completely off. Free.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/4956218218_903039baa1_m2.jpg",
        "alt": "Carpe Diem",
        "title": "Carpe Diem"
      }}></img></p>
    <p><em parentName="p">{`What's so special about a day off`}</em>{`, you might think, `}<em parentName="p">{`I have like two every week!`}</em>{` Or if you're more like me, you're thinking `}<em parentName="p">{`Psh! Dude, I get a day off almost every month.`}</em></p>
    <p>{`This was different - I had a day off from `}<em parentName="p">{`me`}</em>{`.`}</p>
    <p>{`None of my little rituals. No exercise in the morning. Not a single cup of tea. No jotting down random-ish actions into `}<a parentName="p" {...{
        "href": "http://www.daytum.com/",
        "title": "Daytum"
      }}>{`Daytum`}</a>{`. No tweeting. No instagraming. No marking down every bite into `}<a parentName="p" {...{
        "href": "http://www.myfitnesspal.com/"
      }}>{`myfitnesspal`}</a>{`. No time trackers. No email. Nothing.`}</p>
    <p>{`Even wrote the `}<a parentName="p" {...{
        "href": "http://750words.com/"
      }}>{`750words`}</a>{` at almost midnight.`}</p>
    <p>{`For a whole day I completely threw away every little thing I do day after day that doesn't bring a rush of oxytocin there and then. Yes, I will continue doing all those things today, no, none of it is particularly useful, yes, they all tickle the nerd inside me.`}</p>
    <p>{`I took one more step. I didn't worry about the pile of email I'd return to. The day's lull in my data, or the delay in stuff I'm working on.`}</p>
    <p>{`A day like there's no tomorrow! Carpe Diem is fine and all, but dear god we all take it so seriously. When did we collectively forget to `}<em parentName="p">{`enjoy ourselves`}</em>{`? That Carpe Diem wasn't `}{`[`}{`just] about working day and night to get the upper hand on your competition ...`}</p>
    <p>{`It felt great and against all expectations, my life is not a barren wasteland today.`}</p>
    <p>{`I didn't devolve into a fumbling beast, all my good habits are still there. I'm still posting my daily blog. Still tweeting like mad. And still dutifully recording all the useless data about my life. I will even do some work despite Jan 2nd being a public holiday.`}</p>
    <p>{`If you didn't do anything even remotely like this yesterday - shame on you! You're an even bigger nutcase than I am!`}</p>
    <p>{`Give it a try tomorrow, I dare you.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://hopenrecovery.wordpress.com/2011/12/30/carpe-diem-2012/"
        }}>{`Carpé Diem 2012`}</a>{` (hopenrecovery.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stephenhilder.wordpress.com/2011/12/30/carpediem/"
        }}>{`Carpe Diem`}</a>{` (stephenhilder.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rd2recovery.wordpress.com/2011/12/30/carpe-diem-2012/"
        }}>{`Carpé Diem 2012`}</a>{` (rd2recovery.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://jpshealthylivingblog.wordpress.com/2011/12/30/2012-goals/"
        }}>{`2012 Goals`}</a>{` (jpshealthylivingblog.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3b8af50e-bc08-48b8-af2f-82f257294ca0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      